exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-body[data-v-1732bc2c]{padding:0.27778rem\n}\n.page-body ul li[data-v-1732bc2c]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;position:relative;-webkit-align-content:center;-ms-flex-line-pack:center;align-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;height:1.4rem;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;border-bottom:solid 0.025rem #efeff1\n}\n.page-body ul li strong[data-v-1732bc2c]{color:#585858;font-size:0.4rem;font-weight:normal\n}\n", ""]);

// exports
